import React from 'react';
import CompliancePage from '../components/CompliancePage';
import { COMPLIANCE_PAGES } from '../config';

const ShippingPolicyPage = () => {
  return <CompliancePage pageData={COMPLIANCE_PAGES.shippingPolicy} />;
};

export default ShippingPolicyPage;
